/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateMeetingCommandResult } from '../../models/create-meeting-command-result';

export interface ApiMeetingsCreateMeetingPost$Plain$Params {
      body?: {
'Name'?: string;
'Description'?: string;
'Place'?: string;
'Axes'?: string;
'Dauration'?: number;
'MeetingUsers'?: Array<string>;
'Date'?: string;
'Attachments'?: Array<Blob>;
}
}

export function apiMeetingsCreateMeetingPost$Plain(http: HttpClient, rootUrl: string, params?: ApiMeetingsCreateMeetingPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateMeetingCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiMeetingsCreateMeetingPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateMeetingCommandResult>;
    })
  );
}

apiMeetingsCreateMeetingPost$Plain.PATH = '/api/Meetings/CreateMeeting';
